"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Calendar, Clock } from "lucide-react";
export default function WeddingSchedule() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return;
}